import axios from 'axios';
import {getToken, removeToken, removeUserInfo} from "./auth";
import store from '../store'
import {publicPath} from '@/utils/config';
import { Notification, MessageBox, Message, Loading } from 'element-ui';
import errorCode from '@/utils/errorCode';
import cache from '@/plugins/cache';
import { tansParams, blobValidate } from '@/utils/ruoyi';
import Vue from "vue";

import i18n from "@/common/lang"
import {resolveLoginRedirect} from "@/utils/index";
// console.log(i18n.t("system_text1"))

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

let requestLoadingCount = 0;
let requestLoadingInstance = null;

function shouldShowRequestLoading(config) {
    if (!config || config.noLoading) {
        return false;
    }
    if (config.showLoading) {
        return true;
    }
    const method = (config.method || 'get').toLowerCase();
    return method !== 'get';
}

function showRequestLoading(config) {
    if (!shouldShowRequestLoading(config)) {
        return;
    }
    if (requestLoadingCount === 0) {
        requestLoadingInstance = Loading.service({
            lock: true,
            text: config.loadingText || '',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            customClass: 'global-request-loading',
        });
    }
    requestLoadingCount += 1;
}

function hideRequestLoading(config) {
    if (!shouldShowRequestLoading(config)) {
        return;
    }
    requestLoadingCount = Math.max(requestLoadingCount - 1, 0);
    if (requestLoadingCount === 0 && requestLoadingInstance) {
        requestLoadingInstance.close();
        requestLoadingInstance = null;
    }
}

export function resetRequestLoading() {
    requestLoadingCount = 0;
    if (requestLoadingInstance) {
        requestLoadingInstance.close();
        requestLoadingInstance = null;
    }
}

function redirectToLogin() {
    const loginPath = resolveLoginRedirect();
    removeUserInfo();
    removeToken();
    isRelogin.show = false;
    window.location.href = loginPath;
}

function showReloginModal(title) {
    if (isRelogin.show) {
        return new Promise(() => {});
    }
    isRelogin.show = true;
    return MessageBox.confirm(i18n.t("system_text3"), title, {
        confirmButtonText: i18n.t("system_text4"),
        cancelButtonText: i18n.t("system_text5"),
        type: 'warning',
    }).then(() => {
        redirectToLogin();
    }).catch(() => {
        isRelogin.show = false;
    });
}
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';

const axiosBasic = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: process.env.VUE_APP_BASE_API,
    // 超时
    timeout: 30000,
});



// http请求拦截器
axiosBasic.interceptors.request.use((config) => {
    let _lang = i18n.locale;
    let _langText = '';
    if(_lang === 'en-US') {
        _langText = 'en'
    } else if(_lang === 'zh-TW') {
        _langText = 'hk'
    } else {
        _langText = 'cn'
    }
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken();
        // Allow callers to force a language (e.g. edit forms that need both CN/EN fields)
        if (!config.headers['x-lang']) {
            config.headers['x-lang'] = _langText;
        }
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let _params = config.params;

        let url = config.url + '?' + tansParams(_params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
        let _data = config.data;

        const requestObj = {
            url: config.url,
            data: typeof config.data === 'object' ? JSON.stringify(_data) : _data,
            time: new Date().getTime(),
        };
        const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
        const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
        if (requestSize >= limitSize) {
            console.warn(`[${config.url}]: ` + i18n.t("system_text1"));
            return config;
        }
        const sessionObj = cache.session.getJSON('sessionObj');
        if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
            cache.session.setJSON('sessionObj', requestObj);
        } else {
            const s_url = sessionObj.url; // 请求地址
            const s_data = sessionObj.data; // 请求数据
            const s_time = sessionObj.time; // 请求时间
            const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
            if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                const message = i18n.t("system_text2");
                console.warn(`[${s_url}]: ` + message);
                // return Promise.reject(new Error(message));
            } else {
                cache.session.setJSON('sessionObj', requestObj);
            }
        }
    }
    if (process.env.NODE_ENV === 'development') {
        config.url = publicPath() + config.url;
    }
    showRequestLoading(config);
    return config;
}, (error) => {
    hideRequestLoading(error && error.config);
    //请求超时，关闭loading并且提示
    console.log(error);
    return Promise.reject(error);
});

// http响应拦截器
axiosBasic.interceptors.response.use(res => {
    hideRequestLoading(res.config);
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default'];
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
        return res;
    }
    if (code === 20004) {
        showReloginModal(i18n.t("system_text6"));
        return new Promise(() => {});
    }
    if (code !== 200 && res.config && res.config.silentError) {
        return Promise.reject({
            response: { status: code },
            data: res.data,
            config: res.config,
            message: msg,
        });
    }
    if (code === 401) {
        showReloginModal(i18n.t("system_text11"));
        return new Promise(() => {});
    } else if (code === 500) {
        Message({ message: msg, type: 'error' });
        return Promise.reject(new Error(msg));
    } else if (code === 601) {
        Message({ message: msg, type: 'warning' });
        return Promise.reject('error');
    } else if (code !== 200) {
        Notification.error({ title: msg });
        return Promise.reject('error');
    } else {
        return res.data;
    }
}, (error) => {
    hideRequestLoading(error && error.config);
    console.log('err' + error);
    if (error && error.config && error.config.silentError) {
        return Promise.reject(error);
    }
    let { message } = error;
    if (message === 'Network Error') {
        message = i18n.t("system_text7");
    } else if (message.includes('timeout')) {
        message = i18n.t("system_text8");
    } else if (message.includes('Request failed with status code')) {
        message = i18n.t("system_text9") + message.substr(message.length - 3) + i18n.t("system_text10");
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 });
    return Promise.reject(error);
});

export default axiosBasic;
